/* src/courses/api.js */

import gql from 'graphql-tag';

const COURSE_FRAGMENT = gql`
  fragment CourseFragment on Course {
    _id
    totalLessonsBooked
    currentLessonsBooked
    tutorsOnBoarded
    availableTutorsCount
    requestsByStudentsCount
    studentsRequesting {
      _id
      user {
        _id
        email
        first
        last
      }
    }
    availableTutors {
      _id
      user {
        _id
        first
        last
        email
      }
    }
    nonAvailableTutors {
      _id
      user {
        _id
        first
        last
        email
      }
    }
    subject
    number
    title
    university {
      _id
      name
    }
    active
  }
`;

export const FETCH_COURSES_ADMIN_QUERY = gql`
  query fetchCoursesAdmin($filter: CourseFilterInput, $page: PaginationInput, $sort: [SortInput!]) {
    list: coursesAdmin(filter: $filter, page: $page, sort: $sort) {
      count
      courses {
        _id
        subject
        number
        title
      }
    }
  }
`;

export const FETCH_COURSES_QUERY = gql`
  query fetchCourses($filter: CourseFilterInput, $page: PaginationInput, $sort: [SortInput!]) {
    courses(filter: $filter, page: $page, sort: $sort) {
      ...CourseFragment
    }
  }
  ${COURSE_FRAGMENT}
`;

export const ADD_COURSE_MUTATION = gql`
  mutation addCourse($university: ID!, $courseInput: CourseInput!) {
    addCourse(_university: $university, input: $courseInput) {
      ...CourseFragment
    }
  }
  ${COURSE_FRAGMENT}
`;

export const EDIT_COURSE_MUTATION = gql`
  mutation editCourse($course: ID!, $courseInput: CourseInput!) {
    editCourse(_course: $course, input: $courseInput) {
      ...CourseFragment
    }
  }
  ${COURSE_FRAGMENT}
`;

export const REMOVE_COURSE_MUTATION = gql`
  mutation removeCourse($course: ID!) {
    removeCourse(_course: $course)
  }
`;

export const SEARCH_COURSES_QUERY = gql`
  query searchCourses($university: ID!, $input: [SearchCourseInput!]!) {
    searchCourses(_university: $university, input: $input) {
      _id
      result {
        _id
        subject
        number
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/modules/courses/api.js